export default "__VITE_ASSET__Cdov2Jgo__"